export default __webpack_public_path__ + "static/media/port5.5a062fe6.jfif";